<div class="items-table"
  [class.items-table--color-size]="itemDisplayMode === 'color-size'">

  <div class="item-row item-row--header">
    <div class="item-cell"></div>
    @if (itemDisplayMode === 'full') {
      <div class="item-cell"
      ></div>
    }
    <div class="item-cell">{{'CUSTOM_SHIP_DATES.COL_ORDER_ITEM' | translate}}</div>
    <div class="item-cell">{{'CUSTOM_SHIP_DATES.QTY' | translate}}</div>
    <div class="item-cell">{{'CUSTOM_SHIP_DATES.ORIGINAL_DATE' | translate}}</div>
    <div class="item-cell">{{'MENU.CUSTOM_DATE' | translate}}</div>
    <div class="item-cell"></div>
  </div>

  @for (itemIndex of effectiveItemIndexes; track trackByValue($index, itemIndex)) {
    <!-- Data row -->
    <div class="item-row item-row--data"
         [ngClass]="{'text-danger': getItemForm(itemIndex).get('customDates').invalid
                         && (getItemForm(itemIndex).get('customDates').value?.length > 0) && getItemForm(itemIndex).touched || !getItemForm(itemIndex).get('invalidCustomization').value}"
         [formGroup]="getItemForm(itemIndex)">
      <div class="item-cell">
        <div class="custom-control custom-checkbox">
          <input type="checkbox"
            class="custom-control-input"
            formControlName="isChecked"
            [id]="componentId + idPrefix + itemIndex" />
            <label class="custom-control-label"
            [for]="componentId + idPrefix + itemIndex"></label>
          </div>
        </div>
        @if (itemDisplayMode === 'full') {
          <div class="item-cell"
            >
            <img imageSize
              [src]="getItemForm(itemIndex).get('img').value"
              alt=""
              style="width: 42px; height: 42px; object-fit: cover;">
            </div>
          }
          @if (itemDisplayMode === 'full') {
            <div class="item-cell item-cell--order-item"
              >
              <div class="truncate">
                {{getItemForm(itemIndex).get('productCode').value}} / {{getItemForm(itemIndex).get('color').value}} / {{getItemForm(itemIndex).get('size').value}}
              </div>
              <div class="margin-top-small truncate"
              [title]="getItemForm(itemIndex).get('productTitle').value">{{getItemForm(itemIndex).get('productTitle').value}}</div>
            </div>
          }
          @if (itemDisplayMode === 'color-size') {
            <div class="item-cell item-cell--order-item"
              >
              <div class="truncate">Color code: {{getItemForm(itemIndex).get('color').value}}</div>
              <div class="margin-top-small truncate">Size: {{getItemForm(itemIndex).get('size').value}}</div>
            </div>
          }
          <div class="item-cell">
            <div>{{getItemForm(itemIndex).get('qty').value}}</div>
            @if (showStockQty) {
              <div
                class="margin-top-small">
                {{getItemForm(itemIndex).get('stockQty').value}}
              </div>
            }
          </div>
          <div class="item-cell">
            {{getItemForm(itemIndex).get('requestedDeliveryDate').value | date:'d MMM y'}}
          </div>
          <div class="item-cell">
            @if (getEffectiveCustomDates(itemIndex); as customDates) {
              @if (customDates?.length === 0) {
                <b>-</b>
              }
              @if (customDates?.length === 1) {
                <b>{{customDates[0].date | date:'d MMM y'}}</b>
              }
              @if (getCustomDateRange(itemIndex); as range) {
                <b>{{range.minDate | date:'d MMM y'}} - {{range.maxDate | date:'d MMM y'}}</b>
              }
            }
          </div>
          <div class="item-cell d-flex flex-row f-gap-small align-items-center">
            <!-- EDIT_DATE: solo quando non ci sono custom dates E accordion chiuso -->
            @if (!hasCustomDates(itemIndex) && !isExpanded(itemIndex)) {
              <span class="btn btn-outline-primary d-flex align-items-center justify-content-center"
                [class.disabled]="!getItemForm(itemIndex).get('invalidCustomization').value"
                (click)="getItemForm(itemIndex).get('invalidCustomization').value && onAddDate(itemIndex)">
                {{'CUSTOM_SHIP_DATES.EDIT_DATE' | translate}}
              </span>
            }
            <!-- ADD_NEW_DATE: solo quando accordion è aperto -->
            @if (isExpanded(itemIndex) && supportsSplitDelivery) {
              <span class="btn btn-outline-primary d-flex align-items-center justify-content-center"
                [class.disabled]="!getItemForm(itemIndex).get('invalidCustomization').value"
                (click)="getItemForm(itemIndex).get('invalidCustomization').value && onAddDate(itemIndex)">
                {{'CUSTOM_SHIP_DATES.ADD_NEW_DATE' | translate}}
              </span>
            }
            <!-- Toggle: solo quando ci sono custom dates; chiuso="Edit Date", aperto="✕" -->
            @if (hasCustomDates(itemIndex) && !isExpanded(itemIndex)) {
              <span
                class="btn btn-outline-primary d-flex align-items-center justify-content-center"
                (click)="openAccordion(itemIndex)">
                {{'CUSTOM_SHIP_DATES.EDIT_DATE' | translate}}
              </span>
            }
            @if (isExpanded(itemIndex)) {
              <span
                class="btn btn-icon btn-outline-primary"
                (click)="closeAccordion(itemIndex)">
                <span data-feather="x"></span>
              </span>
            }
          </div>
        </div>
        <!-- Expandable form panel -->
        @if (isExpanded(itemIndex)) {
          <div class="item-panel"
            >
            @if (supportsSplitDelivery && showStockQty) {
              <div class="d-flex justify-content-end"
                >
                <button type="button"
                  class="btn btn-outline-primary btn-sm margin-right"
                  (click)="stockDateAdded.emit(itemIndex)"
                  [disabled]="!getItemForm(itemIndex).get('invalidCustomization').value || !getItemForm(itemIndex).get('stockQty')?.value"
                  rippleEffect>
                  {{'VARIANT_GRID.ADD_DATE_WITH_STOCK' | translate}}
                </button>
              </div>
            }
            @for (cd of getCustomDates(itemIndex).controls; track cd; let cDateIndex = $index) {
              @if (isCustomDateVisible(cd)) {
                <div class="mb-1"
                  >
                  <div class="d-flex f-gap-small"
                    [formGroup]="cd">
                    <div class="form-group m-0 flex-grow-1">
                      <label>{{'CUSTOM_SHIP_DATES.DATE' | translate}}{{cd.get('isStockDate').value ? ' (in stock)' : ''}}</label>
                      <app-custom-date-time-picker [dateTime]="cd.get('date').value"
                        [enableCheckDateOnRange]="false"
                        [min]="getMinCustomDate(itemIndex)"
                        [max]="maxStoreCustomDate"
                        [disableClearBtn]="true"
                        (dateTimeEmit)="dateTimeChanged.emit({ ev: $event, form: cd.get('date') })">
                      </app-custom-date-time-picker>
                    </div>
                    <div class="form-group m-0 flex-grow-1">
                      <label>Qty {{cd.get('isStockDate').value ? (' (max in stock '+ getItemForm(itemIndex).get('stockQty').value +')') : ''}}</label>
                      <input type="number"
                        [ngClass]="{'is-invalid': cd.get('qty').invalid && cd.touched}"
                        class="form-control"
                        formControlName="qty"
                        [readonly]="!supportsSplitDelivery"
                        [class.bg-light]="!supportsSplitDelivery"
                        placeholder="Enter qty" />
                      </div>
                      <div class="form-group m-0 button">
                        <button type="button"
                          class="btn btn-icon btn-outline-danger"
                          (click)="dateRemoved.emit({ orderItemIndex: itemIndex, customDateIndex: cDateIndex })"
                          rippleEffect>
                          <span data-feather="trash"></span>
                        </button>
                      </div>
                    </div>
                    @if (cd.get('date').errors?.currentDateOverMaxDate || cd.get('date').errors?.currentDateEqualsRequestedDate) {
                      <small class="text-danger"
                        >
                        {{(cd.get('date').errors?.currentDateOverMaxDate || cd.get('date').errors?.currentDateEqualsRequestedDate) | translate}}
                      </small>
                    }
                  </div>
                }
              }
              @if (getItemForm(itemIndex).get('customDates').errors && getItemForm(itemIndex).touched) {
                <small class="text-danger"
                  >
                  {{(getItemForm(itemIndex).get('customDates').errors?.maxQtyReached ||
                  getItemForm(itemIndex).get('customDates').errors?.minQtyNotReached ||
                  getItemForm(itemIndex).get('customDates').errors?.duplicateDate) | translate}}
                </small>
              }
            </div>
          }
        }

      </div>